// 正式
// const VUE_APP_WS_URL = "wss://api.aurexsx.com/websocket";
// const VUE_APP_BASEURL = ""https://api.aurexsx.com";
// 测试
// const VUE_APP_WS_URL = "wss://hjapi.caicai88888.top/websocket";
// const VUE_APP_BASEURL = "https://hjapi.caicai88888.top";
// 本地
const VUE_APP_WS_URL = "ws://hjapi.caicai88888.top/websocket";
const VUE_APP_BASEURL = "https://hjapi.caicai88888.top";

export { VUE_APP_WS_URL, VUE_APP_BASEURL };
